export default __webpack_public_path__ + "static/media/olivier.aff95b1f.png";